import { render, staticRenderFns } from "./studyGardens_ec.vue?vue&type=template&id=dfe68098&scoped=true&"
import script from "./studyGardens_ec.vue?vue&type=script&lang=js&"
export * from "./studyGardens_ec.vue?vue&type=script&lang=js&"
import style0 from "./studyGardens_ec.vue?vue&type=style&index=0&lang=less&"
import style1 from "./studyGardens_ec.vue?vue&type=style&index=1&id=dfe68098&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfe68098",
  null
  
)

component.options.__file = "studyGardens_ec.vue"
export default component.exports